// This is just an example,
// so you can safely delete all default props below

export default {
  download: {
    preparing_files: 'Προετοιμασία Αρχείων',
    please_wait: 'Παρακαλώ περιμένετε...',
    collecting_documents: 'Συλλέγουμε τα έγγραφα της αίτησης',
    error_message: 'Δεν μπορέσαμε να δημιουργήσουμε το αρχείο.',
    try_again: 'Προσπάθεια Ξανά',
    download_started: 'Η λήψη ξεκίνησε!',
    browser_settings_hint:
      'Αν η λήψη δεν ξεκίνησε αυτόματα, ελέγξτε τις ρυθμίσεις του browser σας.',
    fail_notify: 'Αποτυχία λήψης αρχείου Zip.',
  },
  application_messages: {
    title: 'Επικοινωνία με Γραμματεία',
    no_messages: 'Δεν υπάρχουν μηνύματα ακόμα.',
    you: 'Εσείς',
    secretary: 'Γραμματεία',
    placeholder: 'Γράψτε το μήνυμά σας...',
    send: 'Αποστολή',
  },
  documents: {
    type_certification: 'Επιλογή Πιστοποίησης',
    type_language: 'Επιλογή Πτυχίου Ξένης Γλώσσας',
    type_degree: 'Επιλογή Τίτλου Σπουδών',
    type_work_experience: 'Επιλογή Προϋπηρεσίας',
    type_cv: 'Επιλογή Βιογραφικού Σημειώματος',
    type_document: 'Επιλογή αρχείου',
    type_general: 'Επιλογή Δικαιολογητικού',
    upload_action: 'Μεταφόρτωση Αρχείου',
    profile_action: 'Επιλογή από Προφίλ',
    archived: 'Αρχειοθετημένο',
    view_doc: 'Προβολή εγγράφου',
    no_docs: 'Δεν βρέθηκαν έγγραφα.',
    notes_from_secretary: 'Σημείωμα Γραμματείας',
    required: 'Υποχρεωτικό',
    optional: 'Προαιρετικό',
    no_records_found: 'Δεν βρέθηκαν εγγραφές',
    uploaded_file: 'Ανεβασμένο Αρχείο',
    delete: 'Διαγραφή',
    cancel: 'Ακύρωση',
    files_count: 'Αρχεία',
    max_files: 'Μέγιστα αρχεία',
    submit_upload: 'Μεταφόρτωση αρχείων',
    upload_replacement: 'Ανέβασμα νέου αρχείου',
    replacement_requested: 'Ζητήθηκε αντικαταστάση του αρχείου',
    missing_file: 'Λείπει',
    delete_file_title: 'Διαγραφή αρχείου',
    delete_file_body: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το αρχείο;',
    hints: {
      multiple_files: 'Μπορείτε να επιλέξετε παραπάνω από 1 αρχεία.',
      single_file_profile: '* Η επιλογή από το προφίλ εισάγει 1 αρχείο ανά καταχώρηση.',
    },
    notifications: {
      upload_remove: 'Το αρχείο διαγράφηκε επιτυχώς!',
      upload_success: 'Το αρχείο ανέβηκε επιτυχώς!',
      upload_error: 'Κάτι πήγε στραβά κατά τη μεταφόρτωση!',
      profile_file_not_found: 'Δεν βρέθηκε αρχείο για αυτή την εγγραφή προφίλ.',
      profile_import_success: 'Το έγγραφο αντλήθηκε από το προφίλ επιτυχώς.',
      file_size_exceeded: 'Το αρχείο "{name}" ξεπερνάει το όριο των {size}.',
      file_type_invalid: 'Ο τύπος του αρχείου "{name}" δεν υποστηρίζεται.',
      upload_cancelled_size: 'Η αποστολή ακυρώθηκε. Ένα ή περισσότερα αρχεία ξεπερνούν τα {size}.',
      delete_error: 'Σφάλμα κατά τη διαγραφή του αρχείου.',
    },
  },
  navbar: {
    menu: {
      agents: 'Ατζέντηδες',
      login: 'Σύνδεση',
      login_agent: 'Ατζέντης',
      login_evaluator: 'Αξιολογητής',
      login_secretary: 'Γραμματεία',
      login_applicant: 'Φοιτητής',
      logout: 'Αποσύνδεση',
      profile: 'Προφίλ',
      applicants: 'Αιτούντες',
      applications: 'Αιτήσεις',
      account: 'Λογαριασμός',
      fav_progs: 'Αγαπημένα προγράμματα',
      edit_profile: 'Διαχείριση προφίλ',
      edit_applications: 'Διαχείριση αιτήσεων',
      programmes: 'Προγράμματα',
      calls: 'Προκηρύξεις',
      navigation: 'Πλοήγηση',
    },
    home: 'Αρχική',
    programs: 'Προγράμματα',
    institutions: 'Ιδρύματα',
    search: 'Αναζητήστε προγράμματα',
    search_hint: 'Πατήστε Enter για Αναζήτηση',
    no_results_found: 'Δεν βρέθηκαν αποτελέσματα',
  },
  pagination: {
    limit: 'Ανά σελίδα',
  },
  home: {
    hero_section: {
      title: 'Καλώς ήρθατε στο',
      subtitle: 'Κάνε την αίτησή σου. Τόσο απλά.',
      paragraph:
        'Το AtSiG (Apply to Study in Greece) είναι μία πλατφόρμα σχεδιασμένη για να διευκολύνει τους φοιτητές να υποβάλλουν αιτήσεις σε προγράμματα σπουδών στην Ελλάδα και για να απλοποιήσει τη διαχείριση αιτήσεων από τις γραμματείες των ελληνικών πανεπιστημίων.',
      btn1_label: 'Τα προγράμματά μας',
      btn2_label: 'Τα πανεπιστήμιά μας',
    },
    directions_section: {
      title: 'Οι ακαδημαϊκές αιτήσεις έγιναν απλές!',
      subtitle:
        'Από τη δημιουργία του προφίλ σας έως την υποβολή της αίτησής σας — όλα όσα χρειάζεστε σε μία πλατφόρμα.',
      col1_header: 'Φτιάξτε το προφίλ σας',
      col1_par:
        'Δημιουργήστε ένα μοναδικό σε εσάς προφίλ με τις πληροφορίες σας, το ακαδημαϊκό σας υπόβαθρο και τα επιτεύγματά σας, τα πιστοποιητικά γλωσσών σας, και πολλά άλλα!',
      col2_header: 'Αναζητήστε προγράμματα',
      col2_par:
        'Βρείτε το ιδανικό πρόγραμμα σπουδών για εσάς με τη χρήση των φίλτρων αναζήτησης και αποθηκεύστε προγράμματα ως αγαπημένα για να ενημερώνεστε όταν ανοίγουν οι αιτήσεις.',
      col3_header: 'Κάντε την αίτησή σας',
      col3_par:
        'Ένα κλικ, μία αίτηση. Εάν έχετε συμπεριλάβει στο προφίλ σας όλες τις απαραίτητες πληροφορίες και έγγραφα, ξεκινήστε το ακαδημαϊκό σας ταξίδι με ένα απλό κλικ!',
    },
    institutions_section: {
      title: 'Ανώτατα Εκπαιδευτικά Ιδρύματα',
      subtitle: 'Όλα τα ελληνικά ιδρύματα στα χέρια σας.',
      btn_label: 'Δείτε όλα τα ιδρύματα',
    },
    how_to_section: {
      title: "Μάθετε πώς να αξιοποιήσετε στο έπακρο το {'@'}SiG",
      subtitle: 'Νέος εδώ;',
      btn_label: 'Δείτε τον οδηγό',
    },
    programmes_section: {
      title: 'Ανακαλύψτε Προγράμματα',
      subtitle: "Βρέιτε το πρόγραμμα που σας ταιριάζει μέσω του {'@'}SiG",
      btn_label: 'Δείτε όλα τα προγράμματα',
    },
    search_prog_type: 'Τύπος προγράμματος',
    search_prog_name: 'Όνομα προγράμματος',
    search_uni: 'Ίδρυμα',
    search_city: 'Πόλη',
    search_btn: 'Αναζήτηση',
    section1_header: 'Οι ακαδημαϊκές αιτήσεις έγιναν απλές!',

    section2_header: 'Ανώτατα Εκπαιδευτικά Ιδρύματα',
    section2_btn: 'Περισσοτερα Ιδρύματα',
    section3_header: 'Προγράμματα',
    section3_btn: 'Περισσοτερα Προγράμματα',
  },
  footer: {
    home: 'Αρχική',
    about: 'Σχετικά',
    how_to: 'How To',
    privacy_policy: 'Πολιτική Απορρήτου',
    terms_and_conditions: 'Όροι και Προϋποθέσεις',
    footer_subtitle: 'The all in one place for applications and programs',
  },
  institutions: {
    title: 'Αναζήτηση ιδρυμάτων',
    subtitle: 'Βρείτε το ίδρυμα που θα θέλατε να φοιτήσετε!',
    search_description:
      'Αποτελέσματα αναζήτησης για "{term}" σε Ελληνικά Πανεπιστήμια. Σελίδα {page}.',
    search_btn: 'Αναζήτηση',
    institution_name: 'Τίτλος ιδρύματος',
    visit_btn: 'Ιστότοπος',
    not_found: 'Δεν βρέθηκαν ιδρύματα!',
    open_btn: 'Προγράμματα',
  },
  institution_details: {
    programs: 'Προγράμματα',
    programs_not_found: 'Δεν βρέθηκαν προγράμματα!',
    visit_btn: 'Ιστότοπος',
    open_btn: 'Προβολή',
    breadcrumb: {
      home: 'Αρχική',
      universities: 'Ιδρύματα',
    },
  },
  programs: {
    meta_description:
      'Ανακαλύψτε όλα τα διαθέσιμα προγράμματα σπουδών, προπτυχιακά και μεταπτυχιακά, από τα κορυφαία πανεπιστήμια. Φιλτράρετε βάσει αντικειμένου, πόλης και διδάκτρων.',
    filtered_description:
      'Βρέθηκαν {count} προγράμματα σπουδών για {type}. Δείτε αναλυτικές πληροφορίες για προϋποθέσεις εισαγωγής, δίδακτρα και αιτήσεις στην πλατφόρμα AtSiG.',
    programs_not_found: 'Δεν βρέθηκαν προγράμματα!',
    title: 'Αναζήτηση προγραμμάτων',
    subtitle: 'Βρείτε το ιδανικό πρόγραμμα!',
    program_title: 'Τίτλος προγράμματος',
    search_btn: 'Αναζήτηση',
    view_btn: 'Προβολή',
    open_call: 'Ενεργή προκήρυξη',
    apply_status: "Δυνατότητα αίτησης μέσω {'@'}SiG",
    program_type: 'Τύπος προγράμματος',
    language: 'Γλώσσα',
    study_field: 'Επιστημονικό πεδίο',
    study_mode: 'Μέθοδοι Διδασκαλίας',
    tuition: 'Δίδακτρα',
    institution: 'Ίδρυμα',
    city: 'Πόλη',
    clear_filters: 'καθαρισμος φιλτρων',
    filters: 'Φίλτρα Αναζήτησης',
    fees_yes: 'Με δίδακτρα',
    fees_no: 'Χωρίς δίδακτρα',
    open_yes: 'Με ενεργή προκήρυξη',
    open_no: 'Χωρίς ενεργή προκήρυξη',
    apply_status_yes: 'Με δυνατότητα αίτησης',
    apply_status_no: 'Χωρίς δυνατότητα αίτησης',
    filters_not_found: 'Δεν επιλέχθηκαν φίλτρα αναζήτησης!',
    lang_label: 'Αγγλικά',
    add_fav: 'Προσθήκη στα αγαπημένα',
    remove_fav: 'Aφαίρεση απο τα αγαπημένα',
    collaborating: 'Συνεργαζόμενο',
  },
  call_details: {
    breadcrumb: {
      home: 'Αρχική',
      programs: 'Προγράμματα',
    },
    title: 'Τίτλος',
    programme: 'Πρόγραμμα',
    publish_date: 'Ημερομηνία δημοσίευσης',
    start_date: 'Ημερομηνία έναρξης',
    end_date: 'Ημερομηνία λήξης',
    deadline: 'Προθεσμία υποβολής',
    type: 'Τύπος πρόσκλησης',
    academic_year: 'Ακαδημαϊκό έτος',
    admissions: 'Αριθμός εισακτέων',
    apply: 'Αίτηση',
    call_file: 'Αρχείο',
    description: 'Περιγραφή',
    visit_call: 'Προβολή στο site προγράμματος',
    disciplines: {
      title: 'Διαθέσιμες Κατευθύνσεις',
    },
    documents: {
      title: 'Απαιτούμενα Δικαιολογητικά',
      required: 'Υποχρεωτικό',
      optional: 'Προαιρετικό',
      max_files: 'Μέγιστα Αρχεία',
    },
    language_mismatch_warning:
      'Προσοχή: αυτή η πρόσκληση απευθύνεται σε υποψηφίους των εξής γλωσσών: {languages}. Βεβαιωθείτε ότι το πρόγραμμα σας ταιριάζει πριν κάνετε αίτηση.',
  },
  program_details: {
    name: 'Όνομα προγράμματος',
    visit_btn: 'Ιστότοπος',
    lead_btn: 'Εκδήλωση Ενδιαφέροντος',
    contact_info: 'Επικοινωνία',
    organization: 'Ίδρυμα / Σχολή / Τμήμα',
    university: 'Ίδρυμα',
    department: 'Τμήμα',
    school: 'Σχολή',
    flows: 'Κατευθύνσεις',
    flows_desc: 'Το πρόγραμμα προσφέρει τις ακόλουθες κατευθύνσεις:',
    flows_not_found: 'Δεν βρέθηκαν κατευθύνσεις!',
    languages: 'Γλώσσα/ες Διδασκαλίας',
    gr_collaborating_institutes: 'Ελληνικά συνεργαζόμενα ιδρύματα',
    en_collaborating_institutes: 'Ξένα συνεργαζόμενα ιδρύματα',
    eng_option: 'Διδάσκεται στα Αγγλικά',
    topics: 'Θεματικές Ενότητες',
    study_modes: 'Μέθοδοι Διδασκαλίας',
    tuition_fees: 'Δίδακτρα',
    tuition_fees_tooltip:
      'Τα συγκεκριμένα δίδακτρα δεν ισχύουν παγκοσμίως και ενδέχεται να διαφέρουν ανάλογα με τις υπηρεσίες που προσφέρουν οι συνεργαζόμενοι πάροχοί μας σε διάφορες χώρες, όπως Ινδία, Ινδονησία, Νεπάλ, Καζακστάν, Ουζμπεκιστάν.',
    duration_days: 'Διάρκεια σε ημέρες',
    semesters: 'Διάρκεια φοίτησης',
    master_type: 'Επίπεδο Μεταπτυχιακού',
    bachelor_type: 'Επίπεδο Πτυχίου',
    semesters_tag: 'Εξάμηνα',
    is_part_time: 'Δυνατότητα μερικής φοίτησης',
    scholarship_offered: 'Προσφέρεται Υποτροφία',
    featured_tooltip: 'Προτεινόμενο Πρόγραμμα',
    part_time_semesters: 'Διάρκεια μερικής φοίτησης',
    yes: 'Ναι',
    no: 'Όχι',
    ects: 'ECTS',
    type: 'Τύπος',
    city: 'Πόλη',
    email: 'Email',
    phone: 'Τηλέφωνο',
    calls: 'Περίοδος υποβολής αιτήσεων',
    apply: 'Αίτηση',
    view_call: 'Προβολή',
    click_apply: 'Πατήστε για να κάνετε αίτηση',
    click_apply_future:
      'Η διαδικασία αίτησης θα ενεργοποιηθεί κατά την ημερομηνία έναρξης της προκήρυξης',
    admission_info:
      'Για τους αλλοδαπούς φοιτητές, η αίτηση γίνεται μέσω του Υπουργείου Παιδείας. Για να μάθετε περισσότερα σχετικά με την εισαγωγή, δείτε εδώ: {link}. Η εισαγωγή σε προπτυχιακά προγράμματα που διδάσκονται στα ελληνικά είναι δυνατή μόνο μέσω των Πανελλαδικών Εξετάσεων για τους Έλληνες υποψηφίους.',
    future_application_call: 'Μελλοντική προκήρυξη',
    calls_not_found: 'Δεν υπάρχουν ενεργές αιτήσεις',
    notify_me_description:
      'Εκδηλώστε το ενδιαφέρον σας τώρα για να λάβετε άμεση ενημέρωση μόλις ανοίξουν οι νέες θέσεις.',
    notify_me_btn: 'Ενημερώστε με!',
    breadcrumb: {
      home: 'Αρχική',
      programs: 'Προγράμματα',
    },
  },
  login_modal: {
    login_title: 'Σύνδεση',
    login_subtitle: 'Σύνδεση με τον λογαριασμό σας',
    login_btn: 'Σύνδεση',
    new_user: 'Νέος χρήστης;',
    register_btn: 'Εγγραφή',
    or: 'Εναλλακτικά',
  },
  favorite_programmes: {
    title: 'Αγαπημένα προγράμματα',
    open: 'Άνοιγμα σε νέο παράθυρο',
    remove: 'Αφαίρεση από τα αγαπημένα',
    programs_not_found: 'Δεν βρέθηκαν προγράμματα!',
  },
  applications: {
    filter_type: 'Τύπος Αίτησης',
    search_placeholder: 'Αναζήτηση',
    draft: 'Προσωρινά Αποθηκευμένες',
    finalized: 'Οριστικοποιημένες',
    submitted_at: 'Ημ/νία υποβολής',
    created_at: 'Ημ/νία δημιουργίας',
    call: 'Προκήρυξη',
    program: 'Πρόγραμμα',
    status: 'Κατάσταση',
    applicant: 'Υποψήφιος',
    applicant_status: 'Κατάσταση υποψήφιου',
    actions: 'Ενέργειες',
    applications: 'Αιτήσεις',
    master: 'Μεταπτυχιακά',
    bachelor: 'Προπτυχιακά',
    short_term: 'Μικρής διάρκειας',
    master_applications: 'Αιτήσεις για μεταπτυχιακά',
    bachelor_applications: 'Αιτήσεις για προπτυχιακά',
    short_term_applications: 'Αιτήσεις για προγράμματα μικρής διάρκειας',
    new_btn: 'Νέα Αίτηση',
    open_btn: 'Προβολή',
    delete: 'Διαγραφή',
    edit: 'Επεξεργασία',
    applications_not_found: 'Δεν βρέθηκαν αιτήσεις!',
    breadcrumb: {
      home: 'Αρχική',
      profile: 'Προφίλ',
    },
    delete_title: 'Διαγραφή αίτησης',
    delete_body: 'Σίγουρα θα θέλατε να διαγράψετε την συγκεκριμένη αίτηση;',
    deleted_message: 'Η αίτηση διαγράφηκε επιτυχώς!',
  },
  application_details: {
    not_finalized_title: 'Η αίτηση δεν έχει υποβληθεί',
    not_finalized_desc:
      'Για να δείτε τις λεπτομέρειες αυτής της αίτησης, θα πρέπει πρώτα να την οριστικοποιήσετε και να την υποβάλετε.',
    continue_edit_btn: 'Συνέχεια Επεξεργασίας',
    info_title: 'Πληροφορίες Αίτησης',
    evaluation_title: 'Αξιολόγηση Αίτησης',
    accept_modal_btn: 'Αποδοχή',
    reject_modal_btn: 'Απόρριψη',
    cancel_modal_btn: 'Ακύρωση',
    accept_modal_title: 'Αποδοχή αίτησης',
    reject_modal_title: 'Απόρριψη αίτησης',
    accept_modal_body: 'Σίγουρα θα θέλατε να αποδεχτείτε την συγκεκριμένη αίτηση;',
    reject_modal_body: 'Σίγουρα θα θέλατε να απορρίψετε την συγκεκριμένη αίτηση;',
    application_rejected: 'Έχετε απορρίψει την συσκεκριμένη αίτηση!',
    secretary_file: 'Αρχείο γραμματείας',
    attendance_mode: 'Τύπος Φοίτησης',
    full_time: 'Πλήρης Φοίτηση (Full-Time)',
    part_time: 'Μερική Φοίτηση (Part-Time)',
    extra_fields_title: 'Επιπλέον Στοιχεία',
    yes: 'Ναι',
    no: 'Όχι',
    docs: {
      rejected_banner_title: 'Εκκρεμεί Αντικατάσταση Εγγράφων!',
      rejected_banner_text:
        'Ένα ή περισσότερα δικαιολογητικά σας έχουν απορριφθεί. Παρακαλώ ελέγξτε τις αιτιολογίες και ανεβάστε νέα αρχεία.',
      go_to_documents: 'Μετάβαση στα Έγγραφα',
      upload_new: 'Μεταφόρτωση πρόσθετου εγγράφου',
      pending_title: 'Απαιτούμενες Ενέργειες',
      pending_subtitle:
        'Η γραμματεία ζήτησε τα παρακάτω συμπληρωματικά έγγραφα για την αξιολόγηση της αίτησής σας.',
      call_docs: 'Αρχικά Υποβληθέντα Δικαιολογητικά',
      sec_docs: 'Πρόσθετα Δικαιολογητικά κατόπιν Ελέγχου',
      voluntary_docs: 'Έγγραφα που ανεβάστηκαν απευθείας από τον αιτούντα',
      no_voluntary_docs: 'Δεν έχετε ανεβάσει ακόμη κάποιο έγγραφο',
    },
    program: {
      program_details: 'Πληροφορίες προγράμματος',
      flows: 'Κατευθύνσεις',
      flows_not_found: 'Δεν βρέθηκαν κατευθύνσεις!',
      languages: 'Γλώσσα/ες Διδασκαλίας',
      topics: 'Τομείς σπουδών',
      type: 'Τύπος προγράμματος',
      name: 'Όνομα προγράμματος',
      city: 'Πόλη',
      email: 'Email',
      phone: 'Τηλέφωνο',
      study_modes: 'Μέθοδοι Διδασκαλίας',
      call_deadline: 'Προθεσμία προκήρυξης',
    },
    submitted_at: 'Ημ/νία υποβολής',
    status: 'Κατάσταση',
    application_for: 'Αίτηση για',
    protocol: 'Αριθμός πρωτόκολλου',
    call: 'Προκήρυξη',
    agent_id: 'ID Ατζέντη',
    applicant_comments: 'Σχόλια αιτούντα',
    secretary_comments: 'Σχόλια γραμματείας',
    selected_flows: 'Επιλεγμένες κατευθύνσεις',
    references: 'Προσκλήσεις για συστατικές επιστολές',
    info_choices: 'Πως μάθατε για αυτό το πρόγραμμα',
    file_btn: 'Αρχειο Αίτησης',
    file_banner: 'Η γραμματεία έχει ανεβάσει ένα αρχείο που αφορά την αιτησή σας!',
    view_btn: 'Προβολή',
    accept_btn: 'Αποδοχή',
    reject_btn: 'Απόριψη',
    priority: 'Προτεραιότητα',
    accepted_flow: 'Αποδεκτή',
    add_btn: 'Προσθήκη',
    references_not_found: 'Δεν βρέθηκαν προσκλήσεις για συστατικές επιστολές!',
    ref_from: 'Από',
    accepted_discipline: 'Αποδεκτή κατεύθυνση',
    accept_banner:
      'Η αίτηση έχει γίνει αποδεκτή από την γραμματεία. Τώρα μπορείτε να την αποδεχτείτε κι εσείς, ώστε να ολοκληρωθεί η διαδικασία αξιολόγησης από τη γραμματεία!',
    breadcrumb: {
      home: 'Αρχική',
      profile: 'Προφίλ',
      applications: 'Αιτήσεις',
      details: 'Στοιχεία Αίτησης',
      update: 'Ενημέρωση Αίτησης',
    },
    references_created_message: 'Οι συστατικές επιστολές στάλθηκαν με επιτυχία',
  },
  application_form: {
    page_title: 'Νέα Αίτηση',
    step_1: 'Στοιχεία Αίτησης',
    step_2: 'Δικαιολογητικά',
    multiple_choice: 'Μπορείτε να επιλέξετε παραπάνω από ένα',
    choose_flows_msg:
      'Πρέπει να επιλέξετε τουλάχιστον μία κατεύθυνση για να κάνετε αίτηση στο συγκεκριμένο μεταπτυχιακό!',
    program_details: 'Πληροφορίες Προγράμματος',
    call_details: 'Πληροφορίες Πρόσκλησης',
    view_full_call: 'Πλήρης Προβολή Πρόσκλησης',
    apply_to: 'Αίτηση για',
    agent_id: 'ID Ατζέντη',
    agent_id_hint: 'Προεραιτικό (Συμπληρώστε το ID σας αν είστε ατζέντης)',
    profile_banner:
      'Πριν οριστικοποιήσετε την αίτησή σας, βεβαιωθείτε ότι έχετε ανεβάσει στο προφίλ σας όλα τα απαραίτητα έγγραφα, όπως ακαδημαϊκούς τίτλους, στοιχεία προϋπηρεσίας κ.λπ. Για να μπορέσετε να υποβάλετε αίτηση, θα πρέπει να έχετε καταχωρήσει στο προφίλ σας τουλάχιστον ένα στοιχείο επικοινωνίας σας. Επιπλέον, εάν υποβάλλετε αίτηση για μεταπτυχιακό πρόγραμμα, είναι απαραίτητο να έχετε μεταφορτώσει τον προπτυχιακό τίτλο σπουδών σας στο προφίλ σας.',
    update_profile_btn: 'Ενημέρωση προφιλ',
    profile_check: 'Έλεγχος προφίλ',
    info_choices: 'Πως μάθατε για αυτό το πρόγραμμα;',
    comments: 'Σχόλια',
    comments_hint: 'Προσθέστε κάποια σχόλια αν θέλετε',
    choose_flows: 'Κατευθύνσεις',
    select_flows: 'Επιλογή κατευθύνσεων',
    change_priorities: 'Αλλαγή προτεραιοτήτων',
    save_btn: 'Αποθήκευση Πρόχειρου',
    save_and_continue: 'Αποθήκευση & Επόμενο',
    finalize_btn: 'Οριστική Υποβολή',
    save_and_exit_btn: 'Αποθήκευση & Έξοδος',
    draft_created_message: 'Η αίτηση αποθηκεύτηκε. Προχωρήστε στα δικαιολογητικά.',
    created_message: 'Η αίτηση δημιουργήθηκε με επιτυχία!',
    updated_message: 'Η αίτηση ενημερώθηκε με επιτυχία.',
    finalized_message: 'Η αίτησή σας υποβλήθηκε οριστικά!',
    saved_later_message: 'Η αίτηση αποθηκεύτηκε. Μπορείτε να τη συνεχίσετε αργότερα.',
    missing_requirements_error:
      'Λείπουν υποχρεωτικά έγγραφα ή στοιχεία προφίλ. Παρακαλώ ελέγξτε τις κόκκινες ενδείξεις.',
    priority: 'Προτεραιότητα',
    drag: 'Drag and drop για να αλλάξετε τις προτεραιότητες',
    attendance_mode: 'Επιθυμητός Τύπος Φοίτησης',
    attendance_mode_required: 'Η επιλογή τύπου φοίτησης είναι υποχρεωτική',
    breadcrumb: {
      home: 'Αρχική',
      programs: 'Προγράμματα',
      apply: 'Αίτηση',
    },
    entries: 'Καταχωρήσεις',
    profile: {
      contact_infos: 'Στοιχεία επικοινωνίας',
      education_degrees: 'Ακαδημαϊκά πτυχία',
      language_degrees: 'Πιστοποιητικά γλώσσας',
      work_experiences: 'Πιστοποιητικά εργασιακής εμπειρίας',
      certifications: 'Πιστοποιήσεις',
      other_documents: 'Επιπλέον έγγραφα',
      bachelor: 'Προπτυχιακό πτυχίο',
    },
    reference_modal: {
      header: 'Προσκαλέστε καθηγητές να ανεβάσουν συστατικές επιστολές!',
      input_label: 'Emails καθηγητών',
      input_hint: 'Πολλαπλό (πατήστε enter αφού εισάγετε κάποιο email)',
      submit_btn: 'Αποστολή',
      cancel_btn: 'Ακύρωση',
      rule: 'Παρακαλώ εισάγετε ένα email (πατήστε enter αφού εισάγετε κάποιο email)',
    },
    extra_fields_title: 'Επιπλέον Στοιχεία',
    missing_extra_fields_msg: 'Παρακαλώ συμπληρώστε όλα τα υποχρεωτικά πεδία.',
    field_required: 'Αυτό το πεδίο είναι υποχρεωτικό',
    rule_min_length: 'Τουλάχιστον {n} χαρακτήρες',
    rule_max_length: 'Το πολύ {n} χαρακτήρες',
    rule_greek_only: 'Μόνο ελληνικοί χαρακτήρες',
    rule_latin_only: 'Μόνο λατινικοί χαρακτήρες',
    rule_digits: 'Μόνο ψηφία',
    rule_invalid_format: 'Μη έγκυρη μορφή',
    contact_info_error: 'Απαιτείται τουλάχιστον ένας τρόπος επικοινωνίας.',
    education_degree_error: 'Απαιτείται η προσθήκη τουλάχιστον ενός πτυχίου (BSc).',
    not_eligible_message:
      'Δεν πληροίτε τις προϋποθέσεις για να υποβάλετε αίτηση στην παρούσα πρόσκληση, βάσει της εθνικότητάς σας.',
  },
  profile: {
    save_success: 'Τα στοιχεία αποθηκεύτηκαν με επιτυχία!',
    update_success: 'Τα στοιχεία ενημερώθηκαν με επιτυχία!',
    deleted_success: 'Η καταχώρηση διαγράφηκε.',
    save_error: 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση. Παρακαλώ δοκιμάστε ξανά.',
    delete_error: 'Η διαγραφή δεν ήταν δυνατή. Παρακαλώ δοκιμάστε ξανά.',
    cv: 'Βιογραφικό',
    modal_delete_btn: 'Διαγραφή',
    modal_cancel_btn: 'Ακύρωση',
    change_photo: 'Αλλαγή εικόνας προφίλ',
    email: 'Email',
    mobile_phone: 'Κινητό τηλέφωνο',
    date_of_birth: 'Ημ/νία γέννησης',
    place_of_birth: 'Τόπος γέννησης',
    gender: 'Γένος',
    nationality: 'Ιθαγένεια',
    passport: 'Αριθμός Διαβατηρίου',
    update_profile_btn: 'Ενημέρωση προφιλ',
    update_account_btn: 'Ενημέρωση λογαριασμου',
    view_cv_btn: 'Προβολή βιογραφικού',
    add_btn: 'Προσθήκη',
    edit_btn: 'Επεξεργασία',
    delete_btn: 'Διαγραφή',
    search: 'Αναζήτηση',
    download: 'Ληψη',
    whatsapp_available: 'Διαθέσιμο στο WhatsApp',
    viber_available: 'Διαθέσιμο στο Viber',
    layout: {
      profile: 'Προφίλ',
      contact_infos: 'Στοιχεία επικοινωνίας',
      education_degrees: 'Ακαδημαϊκά πτυχία',
      language_certs: 'Πιστοποιητικά γλωσσών',
      certifications: 'Πιστοποιήσεις',
      work_experiences: 'Εργασιακή εμπειρία',
      other_documents: 'Επιπλέον έγγραφα',
      documents: 'Έγγραφα',
      applications: 'Αιτήσεις',
    },
    contact_infos: {
      table_title: 'Στοιχεία επικοινωνίας',
      not_found: 'Δεν βρέθηκαν στοιχεία επικοινωνίας!',
      columns: {
        country: 'Χώρα',
        city: 'Πόλη',
        address: 'Διεύθυνση',
        postal_code: 'Ταχυδ. κώδικας',
        phone: 'Τηλέφωνο',
        type: 'Τύπος',
      },
      delete_title: 'Διαγραφή στοιχείων επικοινωνίας',
      delete_body: 'Σίγουρα θα θέλατε να διαγράψετε τα συγκεκριμένα στοιχεία επικοινωνίας;',
      deleted_message: 'Τα στοιχεία επικοινωνίας διαγράφτηκαν!',
    },
    education_degrees: {
      table_title: 'Ακαδημαϊκά πτυχία',
      not_found: 'Δεν βρέθηκαν ακαδημαϊκά πτυχία!',
      columns: {
        title: 'Τίτλος',
        type: 'Τύπος',
        country: 'Χώρα',
        grade: 'Βαθμός',
        institution: 'Ίδρυμα / Σχολείο',
        department: 'Τμήμα / Κατεύθυνση',
        enrollment_date: 'Διάρκεια',
      },
      delete_title: 'Διαγραφή ακαδημαϊκού πτυχίου',
      delete_body: 'Σίγουρα θα θέλατε να διαγράψετε το συγκεκριμένο ακαδημαϊκό πτυχίο;',
      deleted_message: 'Το ακαδημαϊκό πτυχίο διαγράφτηκε!',
    },
    language_certs: {
      table_title: 'Πιστοποιητικά γλωσσών',
      not_found: 'Δεν βρέθηκαν πιστοποιητικά γλωσσών!',
      columns: {
        title: 'Τίτλος',
        language: 'Γλώσσα',
        acquisition_date: 'Ημ/νία απόκτησης',
        score: 'Σκόρ',
      },
      delete_title: 'Διαγραφή πιστοποίησης ξένης γλώσσας',
      delete_body: 'Σίγουρα θα θέλατε να διαγράψετε την συγκεκριμένη πιστοποίηση ξένης γλώσσας;',
      deleted_message: 'Το πιστοποιητικό ξένης γλώσσας διαγράφτηκε!',
    },
    certifications: {
      table_title: 'Πιστοποιήσεις',
      not_found: 'Δεν βρέθηκαν πιστοποιήσεις!',
      columns: {
        name: 'Όνομα',
        organization: 'Οργανισμός',
        issue_date: 'Ημ/νία έκδοσης',
        is_expiring: 'Λήγει;',
        credential_id: 'Aναγνωριστικό διαπιστευτηρίου',
        credential_url: 'URL διαπιστευτηρίου',
      },
      not_given: 'Δεν δόθηκε',
      delete_title: 'Διαγραφή πιστοποίησης',
      delete_body: 'Σίγουρα θα θέλατε να διαγράψετε την συγκεκριμένη πιστοποίηση;',
      deleted_message: 'Η πιστοποίηση διαγράφτηκε!',
    },
    work_experiences: {
      table_title: 'Εργασιακή εμπειρία',
      not_found: 'Δεν βρέθηκε κάποια εργασιακή εμπειρία!',
      now: 'Σήμερα',
      columns: {
        position: 'Θέση',
        organization: 'Οργανισμός',
        country: 'Χώρα',
        city: 'Πόλη',
        start_date: 'Διάρκεια',
      },
      delete_title: 'Διαγραφή εργασιακής εμπειρίας',
      delete_body:
        'Σίγουρα θα θέλατε να διαγράψετε την συγκεκριμένη πιστοποίηση εργασιακής εμπειρίας;',
      deleted_message: 'Η πιστοποίηση εργασιακής εμπειρίας διαγράφτηκε!',
    },
    other_documents: {
      table_title: 'Επιπλέον έγγραφα',
      not_found: 'Δεν βρέθηκαν επιπλέον έγγραφα!',
      columns: {
        title: 'Τίτλος',
      },
      delete_title: 'Διαγραφή εγγραφού',
      delete_body: 'Σίγουρα θα θέλατε να διαγράψετε το συγκεκριμένο έγγραφο;',
      deleted_message: 'Το έγγραφο διαγράφτηκε!',
    },
  },
  applicant_form: {
    applicant_create: {
      title: 'Ολοκληρωστε το προφίλ σας ως υποψήφιος φοιτητής',
      subtitle: 'Για να συνεχίσετε θα πρέπει να ολοκληρώσετε το προφίλ σας ως υποψήφιος φοιτητής!',
    },
    step_label: 'Συνέχεια',
    step1_title: 'Προσωπικα στοιχεία',
    step2_title: 'Κοινωνικά προφίλ',
    step3_title: 'Έγγραφα',
    step_final_label: 'Υποβολή',
    step_back_label: 'Πίσω',
    email: 'Email',
    email_rule: 'Παρακαλώ εισάγετε το email',
    password: 'Κωδικός',
    password_rule1: 'Πρέπει να περιέχει τουλάχιστον 8 χαρακτήρες',
    password_rule2: 'Πρέπει να περιέχει τουλάχιστον 1 ψηφίο',
    password_rule3: 'Πρέπει να περιέχει τουλάχιστον 1 κεφαλαίο γράμμα',
    password_rule4: 'Πρέπει να περιέχει τουλάχιστον 1 ειδικό χαρακτήρα',
    password_hint:
      'Πρέπει να περιέχει τουλάχιστον 8 χαρακτήρες, ένα ειδικό χαρακτήρα, ένα ψηφίο και ένα κεφαλαίο γράμμα',
    confirm_password: 'Επιβεβαίωση κωδικού',
    confirm_password_rule1: 'Παρακαλώ είσάγετε ξανά τον κωδικό',
    confirm_password_rule2: 'Οι κωδικοί θα πρέπει να είναι οι ίδιοι',
    first_name_label: 'Όνομα',
    first_name_rule: 'Παρακαλώ εισάγετε το ονομά σας',
    last_name_label: 'Επώνυμο',
    last_name_rule: 'Παρακαλώ εισάγετε το επωνυμό σας',
    date_of_birth_label: 'Ημ/νία γέννησης',
    date_of_birth_hint: 'Μορφή: YYYY-MM-DD',
    date_of_birth_rule1: 'Παρακαλώ εισάγετε την ημ/νία γέννησης σας',
    date_of_birth_rule2: 'Παρακαλώ εισάγετε μία έγκυρη ημ/νία',
    date_of_birth_rule3: 'Παρακαλώ εισάγετε παρελθοντική ημ/νία',
    place_of_birth_label: 'Τόπος γέννησης',
    place_of_birth_rule: 'Παρακαλώ επιλέξτε τον τόπο γέννησης σας',
    no_results: 'Δεν βρέθηκαν αποτελέσματα',
    gender_label: 'Γένος',
    gender_rule: 'Παρακαλώ επιλέξτε γένος',
    nationality_label: 'Ιθαγένεια',
    nationality_rule: 'Παρακαλώ επιλέξτε τουλάχιστον μία ιθαγένεια',
    phone_label: 'Κινητό τηλέφωνο',
    phone_rule1: 'Παρακαλώ εισάγετε το κινητο τηλεφωνό σας',
    phone_rule2: 'Το τηλέφωνο πρέπει να είναι έγκυρο',
    phone_hint: 'Παράδειγμα: +306911111111',
    messaging_apps_label: 'Εφαρμογές επικοινωνίας (προαιρετικά)',
    has_whatsapp: 'Διαθέτω WhatsApp',
    has_viber: 'Διαθέτω Viber',
    id_number_label: 'Αριθμός ταυτότητας ή διαβατηρίου',
    id_number_rule: 'Παρακαλώ εισάγετε τον αριθμό ταυτότητας ή διαβατηρίου',
    linkedin_profile_label: 'Linkedin προφίλ',
    linkedin_profile_hint: "Πρέπει να περιέχει 'https://www.linkedin.com'",
    linkedin_profile_rule: 'Παρακαλώ εισάγαετε ένα έγκυρο Linkedin προφίλ',
    scholar_profile_label: 'Scholar προφίλ',
    scholar_profile_hint: "Πρέπει να περιέχει 'https://scholar.google.com'",
    scholar_profile_rule: 'Παρακαλώ εισάγαετε ένα έγκυρο Scholar προφίλ',
    scopus_profile_label: 'Scopus προφίλ',
    scopus_profile_hint: "Πρέπει να περιέχει 'https://www.scopus.com'",
    scopus_profile_rule: 'Παρακαλώ εισάγαετε ένα έγκυρο Scopus προφίλ',
    cv_label: 'Το βιογραφικό σας',
    cv_hint: 'Mέγιστο μέγεθος αρχείου:5 MB',
    photo_label: 'Εικόνα προφίλ',
    photo_hint: 'Προαιρετικό (Mέγιστο μέγεθος αρχείου:5 MB)',
    terms_label1: 'Συμφωνείτε με τους',
    terms_label2: 'όρους και προϋποθέσεις;',
    terms_rule: 'Πρέπει να αναγνωρίσετε τους όρους και τις προϋποθέσεις.',
    profile_updated_message: 'To προφίλ σας ενημερώθηκε!',
    created_message: 'To προφίλ σας δημιουργήθηκε επιτυχώς!',
  },
  account_form: {
    title: 'Ενημέρωση λογαριασμού',
    input1_label: 'Όνομα',
    input1_rule: 'Παρακαλώ εισάγετε το ονομά σας',
    input2_label: 'Επίθετο',
    inpu2_rule: 'Παρακαλώ εισάγετε το επιθετό σας',
    submit_btn: 'Υποβολή',
  },
  contact_info_form: {
    title: 'Προσθήκη στοιχείων επικοινωνίας',
    edit_title: 'Επεξεργασία στοιχείων επικοινωνίας',
    type_label: 'Τύπος',
    type_rule: 'Παρακαλώ εισάγετε τον τύπο',
    country_label: 'Χώρα',
    country_rule: 'Παρακαλώ εισάγετε την χώρα',
    no_results: 'Δεν βρέθηκαν αποτελέσματα',
    city_label: 'Πόλη',
    city_rule: 'Παρακαλώ εισάγετε την πόλη',
    address_label: 'Διεύθυνση',
    address_rule: 'Παρακαλώ εισάγετε την διεύθυνση',
    postal_code_label: 'Ταχυδρομικός κώδικας',
    postal_code_rule1: 'Παρακαλώ εισάγετε τον ταχυδρομικό κώδικα',
    postal_code_rule2: 'Ο ταχυδρομικός κώδικας πρέπει να περιέχει τουλάχιστον 10 αλφαρηθμιτικά',
    phone_label: 'Τηλέφωνο',
    phone_rule1: 'Παρακαλώ εισάγετε το τηλέφωνο',
    phone_rule2: 'Το τηλέφωνο πρέπει να είναι έγκυρο',
    phone_hint: 'Παράδειγμα : +302101111111',
    submit_btn: 'Υποβολή',
    created_message: 'Τα στοιχεία επικοινωνίας καταχωρήθηκαν!',
    edited_message: 'Τα στοιχεία επικοινωνίας ενημερώθηκαν!',
  },
  education_degree_form: {
    degree_types: {
      high_school: 'Απολυτήριο Λυκείου',
      bsc: 'Πτυχίο (BSc)',
      msc: 'Μεταπτυχιακό (MSc)',
      phd: 'Διδακτορικό (PhD)',
    },
    title: 'Προσθήκη ακαδημαϊκού πτυχίου',
    edit_title: 'Ενημέρωση ακαδημαϊκού πτυχίου',
    hint: 'Αν δεν έχετε αποκτήσει ακόμη το πτυχίο σας μπορείτε να εισάγετε την εκτιμώμενη ημερομηνία απόκτησης χωρίς να ανεβάσετε το πτυχίο σας σε αρχείο.',
    title_label: 'Τίτλος πτυχίου',
    title_rule: 'Παρακαλώ εισάγετε τον τίτλο του πτυχίου',
    type_label: 'Τύπος πτυχίου',
    type_rule: 'παρακαλώ εισάγετε τον τίτλο του πτυχίου',
    enrollment_date_label: 'Hμερομηνία εγγραφής',
    enrollment_date_hint: 'Μορφή: YYYY-MM-DD',
    enrollment_date_rule1: 'Παρακαλώ ειάγετε την ημερομηνία εγγραφής',
    enrollment_date_rule2: 'Παρακαλώ εισάγετε μία έγκυρη ημερομηνία',
    enrollment_date_rule3: 'Παρακαλώ εισάγετε παρελθοντική ημερομηνία',
    graduation_date_label: 'Ημερομηνία αποφοίτησης',
    graduation_date_hint: 'Μορφή: YYYY-MM-DD',
    graduation_date_rule1: 'Παρακαλώ ειάγετε την ημερομηνία αποφοίτησης',
    graduation_date_rule2: 'Παρακαλώ εισάγετε μία έγκυρη ημερομηνία',
    grade_label: 'Βαθμός πτυχίου',
    grade_rule: 'Παρακαλώ εισάγετε τον βαθμό του πτυχίου',
    country_label: 'Χώρα',
    country_rule: 'Παρακαλώ εισάγετε την χώρα',
    no_results: 'Δεν βρέθηκαν αποτελέσματα',
    institution_label: 'Ίδρυμα',
    institution_rule: 'Παρακαλώ εισάγετε το ίδρυμα',
    department_label: 'Τμήμα',
    department_rule: 'Παρακαλώ εισάγετε το τμήμα',
    dissertation_title_label: 'Τίτλος πτυχιακής',
    dissertation_title_hint: 'Προαιρετικό',
    dissertation_abstract_label: 'Περιγραφή θέματος πτυχιακής',
    dissertation_abstract_hint: 'Προαιρετικό',
    degree_file_label: 'Αρχείο πτυχίου',
    degree_file_hint: 'Προαιρετικό (Μέγιστο μέγεθος αρχείου:5 MB)',
    dissertation_file_label: 'Αρχείο πτυχιακής',
    dissertation_file_hint: 'Προαιρετικό',
    submit_btn: 'Υποβολή',
    created_message: 'Το ακαδημαίκό πτυχίο καταχωρήθηκε!',
    edited_message: 'Το ακαδημαίκό πτυχίο ενημερώθηκε!',
    institution_label_hs: 'Όνομα Λυκείου',
    department_label_hs: 'Κατεύθυνση / Ειδικότητα',
    department_hint_hs: 'π.χ. Θετική, Θεωρητική, Πληροφορικής (Αν δεν υπάρχει γράψτε "Γενική")',
    department_rule_hs: 'Παρακαλώ εισάγετε την κατεύθυνση',
  },
  language_cert_form: {
    title: 'Πρόσθηκη πιστοποίησης ξένης γλώσσας',
    edit_title: 'Ενημέρωση πιστοποίησης ξένης γλώσσας',
    title_label: 'Τίτλος πτυχίου',
    title_rule: 'Παρακαλώ εισάγετε τον τίτλο του πτυχίου',
    language_label: 'Γλώσσα',
    language_rule: 'Παρακαλώ εισάγετε την γλώσσα',
    no_results: 'Δεν βρέθηκαν αποτελέσματα',
    score_label: 'Βαθμός',
    score_rule: 'Παρακαλώ εισάγετε βαθμό',
    acquisition_date_label: 'Ημερομηνία απόκτησης πτυχίου',
    acquisition_date_hint: 'Μορφή: YYYY-MM-DD',
    acquisition_date_rule1: 'Παρακαλώ εισάγετε την ημερομηνία απόκτησης πτυχίου',
    acquisition_date_rule2: 'Παρακαλώ εισάγετε μία έγκυρη ημερομηνία',
    acquisition_date_rule3: 'Παρακαλώ εισάγετε παρελθοντική ημερομηνία',
    degree_file_label: 'Το πτυχίο σας σε αρχείο',
    degree_file_hint: 'Μέγιστο μέγεθος αρχείου:5 MB',
    submit_btn: 'Υποβολή',
    created_message: 'H πιστοποίηση ξένης γλώσσας καταχωρήθηκε!',
    edited_message: 'H πιστοποίηση ξένης γλώσσας ενημερώθηκε!',
  },
  other_document_form: {
    title: 'Προσθήκη εγγράφου',
    edit_title: 'Ενημέρωση εγγράφου',
    title_label: 'Τίτλος εγγράφου',
    title_rule: 'Παρακαλώ εισάγετε τον τίτλο του εγγράφου',
    document_file_label: 'Το εγγραφό σας σε αρχείο',
    document_file_hint: 'Μέγιστο μέγεθος αρχείου:5 MB',
    submit_btn: 'Υποβολή',
    created_message: 'Το έγγραφο καταχωρήθηκε!',
    edited_message: 'Το έγγραφο ενημερώθηκε!',
  },
  work_experience_form: {
    title: 'Προσθήκη εργασιακής εμπειρίας',
    edit_title: 'Ενημέρωση εργασιακής εμπειρίας',
    position_label: 'Θέση',
    position_rule: 'Παρακαλώ εισάγετε την θέση',
    organization_label: 'Οργανισμός',
    organization_rule: 'Παρακαλώ εισάγετε τον οργανισμό',
    job_description_label: 'Περιγραφή δουλειάς',
    job_description_rule: 'Παρακαλώ εισάγετε μια περιγραφή',
    country_label: 'Χώρα',
    country_rule: 'Παρακαλώ εισάγετε την χώρα',
    no_results: 'Δεν βρέθηκαν αποτελέσματα',
    city_label: 'Πόλη',
    city_rule: 'Παρακαλώ εισάγετε την πόλη',
    start_date_label: 'Ημερομηνία έναρξης',
    start_date_hint: 'Μορφή: YYYY-MM-DD',
    start_date_rule1: 'Παρακαλώ εισάγετε την ημερομηνία έναρξης',
    start_date_rule2: 'Παρακαλώ εισάγετε μία έγκυρη ημερομηνία',
    start_date_rule3: 'Παρακαλώ εισάγετε παρελθοντική ημερομηνία',
    is_working_label: 'Ακόμη εργάζεστε;',
    end_date_label: 'Ημερομηνία λήξης',
    end_date_hint: 'Μορφή: YYYY-MM-DD',
    end_date_rule1: 'Παρακαλώ εισάγετε την ημερομηνία λήξης',
    end_date_rule2: 'Παρακαλώ εισάγετε μία έγκυρη ημερομηνία',
    end_date_rule3: 'Παρακαλώ εισάγετε παρελθοντική ημερομηνία',
    work_experience_file_label: 'Έγγραφο πιστοποίησης οτι εργαστήκατε',
    work_experience_file_hint: 'Προαιρετικό (Μέγιστο μέγεθος αρχείου:5 MB)',
    submit_btn: 'Υποβολή',
    created_message: 'Η εργασιακή εμπειρία καταχωρήθηκε!',
    edited_message: 'Η εργασιακή εμπειρία ενημερώθηκε!',
  },
  certification_form: {
    title: 'Προσθήκη πιστοποίησης',
    edit_title: 'Επεξεργασία πιστοποίησης',
    name_label: 'Όνομα',
    name_rule: 'Παρακαλώ εισάγετε το όνομα της πιστοποίησης',
    issued_by_label: 'Eκδόθηκε από',
    issued_by_rule: 'Παρακαλώ εισάγετε τον οργανισμό από τον οποίο εκδόθηκε',
    issue_date_label: 'Ημερομηνία έκδοσης',
    issue_date_hint: 'Μορφή: YYYY-MM-DD',
    issue_date_rule1: 'Παρακαλώ εισάγετε την ημερομηνία έκδοσης',
    issue_date_rule2: 'Παρακαλώ εισάγετε μία έγκυρη ημερομηνία',
    issue_date_rule3: 'Παρακαλώ εισάγετε παρελθοντική ημερομηνία',
    is_expiring_label: 'Λήγει?',
    end_date_label: 'Ημερομηνία λήξης',
    end_date_hint: 'Μορφή: YYYY-MM-DD',
    end_date_rule1: 'Παρακαλώ εισάγετε την ημερομηνία λήξης',
    end_date_rule2: 'Παρακαλώ εισάγετε μία έγκυρη ημερομηνία',
    end_date_rule3: 'Παρακαλώ εισάγετε μελλοντική ημερομηνία',
    credential_id_label: 'Aναγνωριστικό διαπιστευτηρίου',
    credential_id_hint: 'Προαιρετικό',
    credential_url_label: 'URL διαπιστευτηρίου',
    credential_url_hint: 'Προαιρετικό',
    certification_file_label: 'Έγγραφο πιστοποίησης',
    certification_file_hint: 'Προαιρετικό (Μέγιστο μέγεθος αρχείου:5 MB)',
    submit_btn: 'Υποβολή',
    created_message: 'Η πιστοποίηση καταχωρήθηκε!',
    edited_message: 'Η πιστοποίηση ενημερώθηκε!',
  },
  reference_form: {
    header: 'Καταχώρηση συστατικής επιστολής',
    applicant_info: 'Πληροφορίες Αιτούντα',
    contact_student: 'Επικοινωνία με τον φοιτητή',
    request_message:
      'Έχει ζητηθεί από εσάς η υποβολή συστατικής επιστολής για την αίτηση στο πρόγραμμα:',
    upload_btn: 'Υποβολή Επιστολής',
    reject_text: 'Δεν επιθυμείτε να υποβάλετε επιστολή;',
    reject_btn: 'Απόρριψη αιτήματος',
    success_upload: 'Η συστατική επιστολή ανέβηκε με επιτυχία!',
    success_reject: 'Το αίτημα απορρίφθηκε.',
    view_existing: 'Προβολή υπάρχοντος αρχείου',
    file_label: 'Επιλογή PDF αρχείου',
    not_found: 'Η πρόσκληση για συστατική επιστολή δεν βρέθηκε!',
    already_uploaded_title: 'Η συστατική επιστολή ελήφθη',
    already_uploaded_desc:
      'Έχετε ήδη ανεβάσει μια συστατική επιστολή για αυτόν τον υποψήφιο. Μπορείτε να δείτε το έγγραφο ή να ανεβάσετε ένα νέο για αντικατάσταση του υπάρχοντος.',
    rejected_title: 'Η αίτηση απορρίφθηκε',
    rejected_message:
      'Έχετε απορρίψει αυτό το αίτημα συστατικής επιστολής. Δεν απαιτείται περαιτέρω ενέργεια από μέρους σας και ο υποψήφιος έχει ενημερωθεί.',
  },
  leads: {
    title: 'Εκδήλωση Ενδιαφέροντος',
    firstName: 'Όνομα',
    lastName: 'Επώνυμο',
    email: 'Email',
    country: 'Χώρα Προέλευσης',
    phone: 'Τηλέφωνο',
    notes: 'Σημειώσεις',
    submit: 'Υποβολή',
    cancel: 'Ακύρωση',
    required: 'Το πεδίο είναι υποχρεωτικό',
    success: 'Επιτυχής υποβολή!',
    error: 'Σφάλμα κατά την υποβολή.',
  },
  agents: {
    title: 'Διαχείριση Agents',
    search: 'Αναζήτηση',
    new_agent: 'Νέος Agent',
    edit_agent: 'Επεξεργασία Agent',
    delete_confirm_title: 'Διαγραφή',
    delete_confirm_msg: 'Είστε σίγουροι ότι θέλετε να διαγράψετε τον {email};',
    fields: {
      email: 'Email',
      first_name: 'Όνομα',
      last_name: 'Επώνυμο',
      role: 'Ρόλος',
      agency_name: 'Όνομα Agency',
      password: 'Κωδικός',
      actions: 'Ενέργειες',
    },
    form: {
      email_rule: 'Παρακαλώ εισάγετε το email',
      password_rule1: 'Πρέπει να περιέχει τουλάχιστον 8 χαρακτήρες',
      password_rule2: 'Πρέπει να περιέχει τουλάχιστον 1 ψηφίο',
      password_rule3: 'Πρέπει να περιέχει τουλάχιστον 1 κεφαλαίο γράμμα',
      password_rule4: 'Πρέπει να περιέχει τουλάχιστον 1 ειδικό χαρακτήρα',
      password_hint:
        'Πρέπει να περιέχει τουλάχιστον 8 χαρακτήρες, ένα ειδικό χαρακτήρα, ένα ψηφίο και ένα κεφαλαίο γράμμα',
      confirm_password: 'Επιβεβαίωση κωδικού',
      confirm_password_rule1: 'Παρακαλώ είσάγετε ξανά τον κωδικό',
      confirm_password_rule2: 'Οι κωδικοί θα πρέπει να είναι οι ίδιοι',
      first_name_rule: 'Παρακαλώ εισάγετε το ονομά σας',
      last_name_rule: 'Παρακαλώ εισάγετε το επωνυμό σας',
    },
    dialog: {
      cancel: 'Ακύρωση',
      submit: 'Υποβολή',
    },
    messages: {
      created: 'Ο Agent δημιουργήθηκε επιτυχώς',
      updated: 'Ο Agent ενημερώθηκε επιτυχώς',
      deleted: 'Ο Agent διαγράφηκε',
    },
  },
  agent_select_field: {
    label: 'Επιλέξτε Agent',
    no_results: 'Δεν βρέθηκαν αποτελέσματα',
  },
  agent: {
    applicants: {
      select_to_continue: 'Για ποιό προφίλ θα θέλατε να κάνετε αίτηση',
      list_title: 'Λίστα Αιτούντων',
      search_placeholder: 'Αναζήτηση με όνομα ή email...',
      new_applicant_btn: 'Νέος Αιτών',
      select_to_manage: 'Επιλέξτε έναν αιτούντα από τη λίστα για διαχείριση',
      created_success: 'Ο αιτών δημιουργήθηκε επιτυχώς',
      no_results: 'Δεν βρέθηκαν αιτούντες',
    },
    new_app: {
      modal_title: 'Έναρξη Νέας Αίτησης',
      select_programme: 'Αναζήτηση Προγράμματος',
      select_call: 'Επιλογή Περιόδου Υποβολής',
      no_active_calls: 'Δεν υπάρχουν διαθέσιμες περίοδοι υποβολής.',
      start_application: 'Δημιουργία Αίτησης',
      cancel: 'Ακύρωση',
      status_open: 'Ενεργό',
    },
  },
  how_to: {
    title: 'Ακολουθήστε αυτόν τον απλό οδηγό για να κάνετε αίτηση στο αγαπημένο σας πρόγραμμα',
    par1: "Πολλοί προσπάθησαν να μπούνε στη διαδικασία υποβολής αιτήσεων για σπουδές στο εξωτερικό,\
      όμως δεν ξέρουν από πού να ξεκινήσουν. Η διαδικασία αίτησης μπορεί να είναι δύσκολη,\
      αλλά δεν θα έπρεπε να είναι! Είτε χρειάζεστε βοήθεια με την αίτηση του ιδρύματος σας είτε με το προφίλ σας, \
      το {'@'}SiG θα σας καθοδηγήσει στα βήματα της αίτησης για τα αγαπημένα σας προγράμματα στην Ελλάδα. \
      Αυτά είναι τα βήματα που χρειάζεστε για να κάνετε αίτηση για οποιοδήποτε ελληνικό ίδρυμα.\
    ",
    title2: 'Πως να κάνετε αίτηση ',
    story1_title: 'Επιλέξτε πού και τι θέλετε να σπουδάσετε',
    story1_par1: 'Αναζήτηση προγραμμάτων και ιδρυμάτων',
    story1_par2: 'Ελέγξτε τα κριτήρια εισδοχής, τα δίδακτρα και τις προθεσμίες.',
    story1_par3: 'Συγκρίνετε διαφορετικά προγράμματα',
    story2_title: 'Συνδεθείτε και συμπληρώστε το προφίλ σας',
    story2_par1: 'Δημιουργήστε τον λογαριασμό σας',
    story2_par2: 'Ολοκληρώστε το προφίλ σας',
    story2_par3: 'Συμπληρώστε όλες τις απαιτούμενες πληροφορίες',
    story3_title: 'Συμπληρώστε τα στοιχεία επικοινωνίας και το εκπαιδευτικό σας ιστορικό',
    story3_par1: 'Προσθέστε τα στοιχεία επικοινωνίας σας',
    story3_par2: 'Συμπληρώστε το εκπαιδευτικό σας ιστορικό',
    story3_par3: 'Συγκεντρώστε όλα τα απαιτούμενα έγγραφα',
    story4_title: 'Υποβάλετε όλα τα έγγραφά σας και συμπληρώστε το προφίλ σας',
    story4_par1: 'Ανεβάστε όλα τα έγγραφα που ζητήθηκαν (μόνο μία φορά)',
    story4_par2: 'Ελέγξτε εάν όλα τα έγγραφα έχουν μεταφορτωθεί σωστά',
    story4_par3: 'Επαληθεύστε τη σύνοψη του προφίλ σας πριν την υποβολή',
    story5_title: 'Περιμένετε ανταπόκριση από το ίδρυμα',
    story5_par1: "Λάβετε ενημερώσεις από το {'@'}SiG σχετικά με τη διαδικασία αποδοχής",
    story5_par2: "Ελέγχετε κατά καιρούς τον πίνακα ελέγχου του {'@'}SiG",
    story5_par3: 'Μείνετε ενημερωμένοι για τη διαδικασία',
  },
  privacy: {
    title: 'AtSiG Πολιτική Απορρήτου',
    desc: {
      p1: "Χαιρόμαστε που επισκεφθήκατε την ιστοσελίδα μας. Καθώς λαμβάνουμε πολύ σοβαρά υπόψη την προστασία των προσωπικών σας δεδομένων, θα θέλαμε να σας ενημερώσουμε για το τι δεδομένα συλλέγονται καπό το σύστημα {'@'}SiG κατά την εγγραφή σας σε αυτό.",
      p2: 'Επειδή η πολιτική απορρήτου ενδέχεται να αλλάζει σύμφωνα με αλλαγές στη νομοθεσία ή τις εσωτερικές διαδικασίες της Study in Greece, σας παρακαλούμε να ελέγχετε την παρούσα δήλωση απορρήτου σε τακτική βάση',
    },
    sections: {
      1: {
        title: '1. ΓΕΝΙΚΑ',
        p1: "Το {'@'}SiG είναι η νέα πλατφόρμα υποβολής και διαχείρισης αιτήσεων σε προγράμματα των ΑΕΙ της χώρας. Για να χρησιμοποιήσετε την πλατφόρμα θα πρέπει να δημιουργήσετε λογαριασμό.",
        p2: 'Ο λόγος για τον οποίο ζητούνται δεδομένα προσωπικού χαρακτήρα, είναι η επιτυχής υποβολή αίτησης σε προγράμματα των ΑΕΙ της χώρας.',
      },
      2: {
        title: '2. ΣΤΟΙΧΕΙΑ ΛΟΓΑΡΙΑΣΜΟΥ',
        p1: 'Κατά τη δημιουργία του λογαριασμού σας, θα ζητηθούν οι παρακάτω πληροφορίες:',
        list: [
          'Ονοματεπώνυμο',
          'Αριθμός διαβατηρίου / ταυτότητας',
          'Ημερομηνία γέννησης',
          'Τόπος γέννησης',
          'Εθνικότητα',
          'Αριθμός τηλεφώνου επικοινωνίας',
          'Διεύθυνση email',
          'Φύλο',
          'Όνομα και email λογαριασμού παρόχου (σε περίπτωση που συνδεθείτε με social login)',
        ],
        p2: 'Η IP του χρήστη καταγράφεται για λόγους ασφαλείας, χωρίς να χρησιμοποιείται για σκοπούς ανάλυσης επισκεψιμότητας.',
        p3: 'Επιπλέον, δεδομένα που συλλέγονται από τρίτες πλατφόρμες όπως Google Analytics και Google Tag Manager θα αναλυθούν στις παραγράφους 7 και 8 (η παρ. 8 αναφέρεται αποκλειστικά στο Google Analytics).',
        p4: 'Για περισσότερες πληροφορίες σχετικά με τη συλλογή και χρήση των δεδομένων σας από αυτές τις πλατφόρμες παρακαλούμε ανατρέξτε στις εκάστοτε πολιτικές απορρήστου.',
      },
      3: {
        title: '3. ΛΟΓΟΙ ΣΥΛΛΟΓΗΣ ΚΑΙ ΕΠΕΞΕΡΓΑΣΙΑΣ ΤΩΝ ΔΕΔΟΜΕΝΩΝ ΣΑΣ',
        p1: 'Η συλλογή και επεξεργασία των δεδομένων σας περιορίζεται στην παροχή των υπηρεσιών της εφαρμογής, δηλαδή την αίτηση σε προγράμματα σπουδών των Ελληνικών ΑΕΙ.',
        p2: 'Κατά τη χρήση του ιστοτόπου apply.studyingreece.edu.gr επεξεργαζόμαστε δεδομένα χρηστών για τους παρακάτω σκοπούς.',
        list: [
          'Παροχή υπηρεσιών μέσω φορμών καταχώρησης πληροφοριών',
          'Διεξαγωγή ανώνυμων ερευνών',
          'Στατιστική ανάλυση',
          'Αποτροπή κακής χρήσης',
        ],
        p3: 'Επιπρόσθετοι λόγοι στατιστικών αναλύσεων που θα βοηθήσουν στην κατανόηση προτιμήσεων σπουδαστών, χωρίς να περιλαμβάνουν πληροφορίες που μπορούν να οδηγήσουν στην ταυτοποίηση χρηστών.',
      },
      4: {
        title: '4. ΠΡΟΣΤΑΣΙΑ ΔΕΔΟΜΕΝΩΝ',
        p1: 'Παίρνουμε όλα τα απαραίτητα τεχνικά και οργανωτικά μέτρα για την αποφυγή απώλειας, κακής χρήσης και αλλοίωσης προσωπικών δεδομένων',
        p2: 'Τα δεδομένα σας αποθηκεύονται σε ασφαλή συστήματα εξυπηρετητών (servers) παρεχόμενους από το Χαροκόπειο Πανεπιστήμιο ή από την ΕΔΥΤΕ Α.Ε. – GRNET και στους οποίους η πρόσβαση παρέχεται μόνο σε εξουσιοδοτημένους χρήστες με χρήση προσωπικών κωδικών ασφαλείας.',
        p3: 'Παρακαλούμε να διατηρείτε τον προσωπικό κωδικό (password) αυστηρά προσωπικό. Μην τον καταχωρείτε σε οποιαδήποτε φόρμα καταχώρησης πληροφοριών, παρά μόνο στην οθόνη σύνδεσης στο λογαριασμό σας.',
      },
      5: {
        title: '5. ΑΛΛΑΓΕΣ ΠΟΛΙΤΙΚΗΣ',
        p1: 'Η πολιτική απορρήτου ενδέχεται να ενημερωθεί, για αυτό παρακαλείσθε να ελέγχετε τακτικά την παρούσα σελίδα και να βεβαιωθείτε ότι συμφωνείτε και αποδέχεστε το σύνολο των παραγράφων. Ενδέχεται να ενημερωθείτε και με προσωπικό email ή μήνυμα στο λογαριασμό σας για αλλαγές στην πολιτική απορρήτου. Τα συγκεκριμένα email δεν θεωρούνται προσωθητικού περιεχομένου.',
      },
      6: {
        title: '6. ΔΙΑΤΗΡΗΣΗ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ',
        p1: 'Η παράγραφος αναφέρεται στις διαδικασίες και πολιτικές διατήρησης των προσωπικών σας δεδομένων, ώστε να συμβαδίζουν με τις νομικές υποχρεώσεις σχετικά με τη διατήρηση και διαγραφή αυτών.',
        p2: 'Τα προσωπικά δεδομένα που επεξεργαζόμαστε για οποιοδήποτε σκοπό δε θα διατηρηθούν στα συστήματά μας για περισσότερο από το αναγκαίο χρονικό διάστημα.',
        p3: 'Οποιαδήποτε στιγμή μπορείτε να αιτηθείτε τη διαγραφή του λογαριασμού σας η οποία συνεπάγεται τη διαγραφή των δεδομένων σας.',
      },
      7: {
        title: '7. COOKIES',
        p1: 'Η πλατφόρμα χρησιμοποιεί cookies:',
        list: [
          'α) Απαραίτητα για τη λειτουργία της εφαρμογής.',
          'β) Cookies από Google Analytics ή Google Tag Manager με ανωνυμοποίηση IP. Cookies από Facebook pixel.',
        ],
        p2: 'Για περισσότερες πληροφορίες επισκεφθείτε την πολιτική των Cookies',
      },
      8: {
        title: '8. GOOGLE ANALYTICS',
        p1: 'Ο ιστότοπος apply.studyingreece.edu.gr χρησιμοποιεί Google Analytics, μια πλατφόρμα ανάλυσης επισκεψιμότητας που παρέχεται από την Google. Το Google Analytics χρησιμοποιεί cookies που απθηκεύονται στη συσκευή σας και επιτρέπει την ανάλυση της χρήσης του ιστοτόπου. Οι πληροφορίες που δημιουργούνται μεταδίδονται σε εξυπηρετητές της Google στην Ευρώπη ενώ ενδέχεται να εποθηκεύονται και στις Ηνωμένες Πολιτείες Αμερικής. Ο παρόν ιστότοπος χρησιμοποιεί τα Google Analytics με την παράμετρο anonimize_ip σε true, για ανωνυμοποίηση της IP του επισκέπτη. Η Google θα χρησιμοποιήσει τις πληροφορίες για τη δημιουργία αναφορών σχετικά με τη χρήση του ιστοτόπου και την παροχή επιπλέον υπηρεσιών σχετικών με τον ιστότοπο και γενικά το διαδίκτυο. Μπορείτε να αποτρέψετε την αποθήκευση cookie ρυθμίζοντας τον φυλλομετρητή σας κατάλληλα, αλλά αποδέχεστε έτσι την ενδεχόμενη μη σωστή και ολοκληρωμένη λειτουργία της εφαρμογής. Επιπλέον μπορείτε να αποτρέψετε τη συλλογή και επεξεργασία των δεδομένων σας από το Google Analytics με χρήση αυτού του εργαλείου.',
      },
      9: {
        title: '9. ΑΠΟΚΑΛΥΨΗ ΔΕΔΟΜΕΝΩΝ',
        p1: 'Κατά κανόνα, δεν αποκαλύπτουμε τα δεδομένα προσωπικού χαρακτήρα σε τρίτα μέρη, εκτός από τις περιπτώσεις που περιγράφονται παρακάτω. Εντούτοις ενδέχεται να τα αποκαλύψουμε αν υποχρεωθούμε από το νόμο ή για λόγους προστασίας της δημόσιας ασφάλειας, όπως για παράδειγμα σε περίπτωση υποψίας εγκληματικής ενέργειας ή κακής χρήσης του ιστοτόπου.',
      },
      10: {
        title: '10. ΤΡΙΤΑ ΜΕΡΗ',
        p1: "Τα μόνα τρίτα μέρη που αποκτούν πρόσβαση στα προσωπικά σας δεδομένα, είναι τα ΑΕΙ που διαθετουν λογαριασμό στην πλατφόρμα, με την προϋπόθεση ότι υποβάλατε αίτηση σε προγράμματα που διαχειρίζονται μέσω του {'@'}SiG. Η πρόσβαση δίδεται μόνο μέσω της πλατφόρμας.",
        p2: 'Μετά την υποβολή αίτησης σε πρόγραμμα, ενδέχεται πληροφορίες σας να καταχωρηθούν σε συστήματα του ιδρύματος, σε πρόγραμμα του οποίου υποβάλατε αίτηση. Σε τέτοια περίπτωση ακόμα και αν διαγράψετε το λογαριασμό σας στο AtSiG, δε συνεπάγεται και διαγραφή των δεδομένων σας από τα τρίτα συστήματα στα οποία ενδέχεται να έχουν καταχωρηθεί και δεν είμαστε υπέυθυνοι για τη χρήση τους σε αυτά.',
        p3: 'Για τις πολιτικές διατήρησης, σφάλειας και διαγραφής των δεδομένων σας από τρίτα συστήματα θα πρέπει να επικοινωνήσετε με τους διαχειριστές αυτών.',
      },
      11: {
        title: '11. ΔΙΑΚΑΙΩΜΑΤΑ ΣΧΕΤΙΚΑ ΜΕ ΤΑ ΠΡΟΣΩΠΙΚΑ ΣΑς ΔΕΔΟΜΕΝΑ',
        p1: 'Σας ενημερώνουμε ότι διατηρείτε κάθε στιγμή τα παρακάτω δικαιώματα.',
        list: [
          'Δικαίωμα διαγραφής ή διόρθωσης δεδομένων.',
          'Δικαίωμα πρόσβασης στα δεδομένα σας.',
          'Μπορείτε να ζητήσετε τη διαβίβαση των δεδομένων σας σε τρίτους',
          'Δικαίωμα αποδοχής της χρήση των δεδομένων σας.',
        ],
      },
      12: {
        title: '12. ΕΠΙΚΟΙΝΩΝΙΑ',
        p1: "Για ερωτήσεις ή σχόλια σχετικά με την πολιτική απορρήτου, παρακαλούμε επικοινωνήστε μαζί μας, δημιουργώντας ticket στο helpdesk και επιλέξτε ως help topic, {'@'}SiG.",
      },
    },
    footer: 'Τελευταία ενημέρωση 06/04/2023',
  },
  terms: {
    title: 'AtSiG Όροι Χρήσης',
    p1: "Δημιουργώντας το λογαριασμό σας στο {'@'}SiG δηλώνετε ότι συμφωνείτε με τους παρακάτω όρους χρήσης.",
    p2: 'Λαμβάνουμε πολύ σοβαρά την προστασία των προσωπικών δεδομένων σας και για την κατανόηση των όρων χρήσης, σας ζητούμε να διαβάσετε προσεκτικά παρακάτω.',
    section1: {
      title: '1. Δεδομένα λογαριασμού',
      p1: 'Συμφωνώντας με τους παρακάτω όρους, αποδέχεστε τη συλλογή και επεξεργασία των προσωπικών σας δεδομένων ως εξής:',
      list: [
        'Υποβάλοντας αίτηση σε πρόγραμμα της επιλογής σας, αποδέχεστε την προβολή του προφίλ σας από τον διαχειριστή του προγράμματος.',
        'Αποδέχεστε την ενδεχόμενη χρήση των δεδομένων σας σε ανωνυμοποιημένη μορφή για σκοπούς στατιστικής ανάλυσης και έρευνας',
        "Αποδέχεστε ότι τα δεδομένα σας ενδέχεται να καταχωρηθούν σε συστήματα τρίτων, π.χ. φοιτητολόγιο ΑΕΙ, μετά από αίτησή σας σε προγράμματα μέσω του {'@'}SiG. Κατά συνέπεια δε φέρουμε ευθύνη για τη συλλογή και χρήση τους από τρίτα συστήματα.",
        "Αποδέχεστε ότι μετά τη διαγραφή των δεδομένων σας στο {'@'}SiG, δε φέρουμε ευθύνη για τη διαγραφή τους και από τρίτα συστήματα στα οποία ενδέχεται να έχουν καταχωρηθεί μετά από αίτησή σας σε προγράμματα μέσω του {'@'}SiG.",
        "Τα δεδομένα που ενδέχεται να διαμοιραστούν σε τρίτο σύστημα κατά την αίτησή σας στο {'@'}SiG δεν περιλαμβάνουν σε καμία περίπτωση τον προσωπικό κωδικό (password) με τον οποίο εισέρχεστε στο λογαριασμό σας. Επιπλέον ο προσωπικός κωδικός σας δεν είναι ορατός σε κανένα μέρος του πληροφοριακού συστήματος {'@'}SiG. Κατά συνέπεια είναι αποκλειστικά δική σας ευθύνη η προστασία και η επιλογή ενός ισχυρού κωδικού πρόσβασης. Προτείνεται η χρήση διαφορετικού κωδικού πρόσβασης.",
      ],
      p2: "Αν δε συμφωνείτε με το σύνολο των παραπάνω, παρακαλούμε μην προχωρήσετε στη δημιουργία λογαριασμού στο {'@'}SiG.",
      p3: 'Για περισσότερες πληροφορίες σχετικά με τη συλλογή και επεξεργασία των προσωπικών σας δεδομένων παρακαλούμε συμβουλευτείτε την Πολιτική Απορρήτου.',
    },
    footer: 'Τελευταία ενημέρωση στις 06/04/2023',
  },
  program_matcher: {
    fab_label: 'Εύρεση Προγράμματος με AI',
    hero_btn: 'Δεν ξέρεις τι να σπουδάσεις; Δοκίμασε το AI',
    title: 'Βρες το πρόγραμμα που σου ταιριάζει',
    step_counter: 'Βήμα {current} από {total}',
    steps: {
      type: {
        question: 'Τι ψάχνεις;',
        options: {
          master: 'Μεταπτυχιακό (MSc/MA/MBA)',
          bachelor: 'Προπτυχιακό (BSc/BA)',
          any: 'Οποιοδήποτε επίπεδο',
        },
      },
      topics: {
        question: 'Ποια πεδία σε ενδιαφέρουν;',
        hint: '(επέλεξε όλα όσα ισχύουν)',
        options: {
          technology: 'Τεχνολογία',
          science: 'Επιστήμες και Μηχανική',
          health: 'Υγεία',
          economics: 'Οικονομία και Διοίκηση',
          humanities: 'Ανθρωπιστικές Επιστήμες',
          environmental: 'Περιβαλλοντικές Επιστήμες',
          social: 'Κοινωνικές Επιστήμες',
          law: 'Νομικές Επιστήμες',
          agriculture: 'Γεωργία',
          politics: 'Πολιτική Επιστήμη',
          arts: 'Καλές Τέχνες',
          education: 'Επιστήμες Αγωγής',
          tourism: 'Τουριστικές Σπουδές',
          sports: 'Αθλητισμός',
        },
      },
      mode: {
        question: 'Πώς θέλεις να σπουδάσεις;',
        options: {
          in_person: 'Δια ζώσης',
          online: 'Εξ αποστάσεως',
          any: 'Χωρίς προτίμηση',
        },
      },
      language: {
        question: 'Σε ποια γλώσσα διδασκαλίας προτιμάς;',
        options: {
          english: 'Αγγλικά',
          greek: 'Ελληνικά',
          any: 'Χωρίς προτίμηση',
        },
      },
      tuition: {
        question: 'Ποιος είναι ο προϋπολογισμός διδάκτρων σου;',
        scholarship: 'Διαθέσιμη υποτροφία',
        open_applications: 'Ανοιχτές αιτήσεις τώρα',
        options: {
          free: 'Μόνο δωρεάν',
          low: 'Έως €3.000',
          mid: 'Έως €7.000',
          any: 'Οποιοσδήποτε προϋπολογισμός',
        },
      },
      free_text: {
        question: 'Κάτι άλλο που πρέπει να ξέρουμε;',
        hint: '(προαιρετικό)',
        boost:
          'Με περισσότερες λεπτομέρειες, η AthenAI βρίσκει αποτελέσματα πολύ πιο κοντά σε αυτό που θέλεις',
        placeholder: 'π.χ. Έχω υπόβαθρο στη βιολογία και θέλω να εστιάσω στη θαλάσσια οικολογία',
        tip: 'Ανάφερε στόχους, υπόβαθρο ή τι περιμένεις από τις σπουδές σου',
        suggestions: {
          career: 'Θέλω να αλλάξω κατεύθυνση από…',
          background: 'Το ακαδημαϊκό μου υπόβαθρο είναι…',
          research: 'Ψάχνω ερευνητικό πρόγραμμα',
          location: 'Προτιμώ να σπουδάσω σε…',
        },
      },
    },
    nav: {
      back: 'Πίσω',
      next: 'Επόμενο',
      find_matches: 'Εύρεση αποτελεσμάτων',
    },
    results: {
      searching: 'Αναζήτηση προγραμμάτων…',
      matched_singular: '1 πρόγραμμα βρέθηκε',
      matched_plural: '{count} προγράμματα βρέθηκαν',
      start_over: 'Εκ νέου αναζήτηση',
      no_matches_title: 'Δεν βρέθηκαν αποτελέσματα',
      no_matches_desc: 'Δοκίμασε να αλλάξεις τα φίλτρα ή τις προτιμήσεις σου.',
      view_program: 'Προβολή προγράμματος',
      not_dream_match: 'Δεν βρήκες αυτό που ήθελες;',
      compare_btn: 'Σύγκριση',
      selected: '✓ Επιλέχθηκε',
      broader_suggestions: 'Γενικότερες προτάσεις',
      view: 'Προβολή',
      compare_selected: '2 προγράμματα επιλεγμένα',
      badges: {
        free: 'Δωρεάν',
        open: 'Ανοιχτό',
        master: 'Μεταπτυχιακό',
        bachelor: 'Προπτυχιακό',
        phd: 'Διδακτορικό',
        in_person: 'Δια ζώσης',
        remotely: 'Εξ αποστάσεως',
      },
    },
    resume: {
      title: 'Καλώς ήρθες ξανά',
      subtitle: 'Η τελευταία σου αναζήτηση',
      matched_singular: '1 πρόγραμμα βρέθηκε',
      matched_plural: '{count} προγράμματα βρέθηκαν',
      new_search: 'Νέα αναζήτηση',
      see_results: 'Δες τα αποτελέσματα',
    },
    refine: {
      title: 'Πες περισσότερα στην AthenAI',
      career_question: 'Ποιοι είναι οι επαγγελματικοί σου στόχοι μετά την αποφοίτηση;',
      career_hint: '— π.χ. "να εργαστώ σε έρευνα ΤΝ", "να ξεκινήσω επιχείρηση"',
      career_placeholder: 'Πες στην AthenAI τι θέλεις να πετύχεις…',
      background_question: 'Ποιο είναι το ακαδημαϊκό σου υπόβαθρο;',
      background_hint: '— π.χ. "Πτυχίο Πληροφορικής", "υπόβαθρο στα οικονομικά"',
      background_placeholder: 'Περίγραψε τις σπουδές ή το υπόβαθρό σου…',
      topics_question: 'Συγκεκριμένα θέματα, τεχνολογίες ή ερευνητικά πεδία;',
      topics_hint: '— όσο πιο συγκεκριμένος/η θέλεις',
      topics_placeholder: 'π.χ. μηχανική μάθηση και κλιματικά μοντέλα…',
      back: 'Πίσω στα αποτελέσματα',
      submit: 'Βρες καλύτερα αποτελέσματα',
      error: 'Κάτι πήγε στραβά. Παρακαλώ δοκίμασε ξανά.',
    },
    compare: {
      title: 'AthenAI · Σύγκριση',
      comparing: 'Η AthenAI συγκρίνει…',
      unavailable: 'Η σύγκριση δεν είναι διαθέσιμη',
      close: 'Κλείσιμο',
      focus: 'Εστίαση',
      best_for: 'Για ποιον',
    },
    match_labels: {
      excellent: '★ Άριστη αντιστοιχία',
      great: 'Πολύ καλή αντιστοιχία',
      good: 'Καλή αντιστοιχία',
      fair: 'Μέτρια αντιστοιχία',
      possible: 'Πιθανή αντιστοιχία',
    },
  },
  about: {
    title: 'Σχετικά με το AtSiG',
    subtitle:
      'Καλώς ήρθατε στο AtSiG, την πλατφόρμα του Study in Greece που στοχεύει να κάνει τη διαδικασία αίτησης στα ελληνικά πανεπιστήμια όσο το δυνατόν πιο απλή και εύκολη. Δημιουργήστε το προφίλ σας, ανεβάστε τα δικαιολογητικά σας και ξεκινήστε τις αιτήσεις!',
    btn_label: 'Μάθετε περισσότερα για το SiG',
    offer_title: "Τι προσφέρει το {'@'}SiG",
    applicant_section: {
      title: 'Για Υποψηφίους:',
      list: [
        'Προβολή όλων των διαθέσιμων μεταπτυχιακών προγραμμάτων από όλα τα Ελληνικά Πανεπιστήμια.',
        "Δείτε ποια προγράμματα σπουδών έχουν ανοιχτές προσκλήσεις εκδήλωσης ενδιαφέροντος ανά πάσα στιγμή και ελέγξτε για ποια από αυτά μπορείτε να κάνετε αίτηση μέσω του {'@'}SiG.",
        'Ακόμα και όταν οι αιτήσεις είναι κλειστές, αποθηκεύστε τα προγράμματα στα αγαπημένα σας και λάβετε ειδοποιήσεις όταν ανοίξουν οι νέες προσκλήσεις!',
        'Η δημιουργία προφίλ για τους υποψηφίους είναι απλή και υποστηρίζει πολλές λειτουργίες, επιτρέποντας πλήρη παραμετροποίηση και εξατομίκευση.',
        'Με όλα τα έγγραφα και τα πιστοποιητικά που ανεβάζετε στο προφίλ σας, μπορείτε να κάνετε αίτηση σε όσα προγράμματα επιθυμείτε με ένα μόνο κλικ!',
      ],
    },
    university_section: {
      title: 'Για Πανεπιστήμια:',
      list: [
        'Με λογαριασμό Γραμματείας, δημοσιεύστε και διαχειριστείτε αναλυτικές περιγραφές προγραμμάτων, συμπληρώνοντας απλώς μια απλή φόρμα.',
        'Ορίστε εύκολα περιόδους αιτήσεων για κάθε πρόγραμμα ξεχωριστά.',
        'Λάβετε αιτήσεις με όλα τα απαραίτητα δικαιολογητικά που έχετε ορίσει για τα προγράμματά σας.',
        'Αξιολογήστε τις αιτήσεις σε ένα φιλικό προς το χρήστη περιβάλλον και ζητήστε απευθείας διευκρινίσεις από τους υποψηφίους.',
        'Οριστικοποιήστε την κατάσταση των αιτήσεων με απαράμιλλη αποτελεσματικότητα και καλωσορίστε τους νέους σας φοιτητές!',
      ],
    },
    our_team_section: {
      title: 'Η Ομάδα μας, Το Όραμά μας',
      par: 'Η ομάδα μας αποτελείται από έμπειρους προγραμματιστές λογισμικού και επαγγελματίες στον τομέα της τριτοβάθμιας εκπαίδευσης. Πρωταρχικός μας στόχος είναι να βοηθήσουμε τους φοιτητές να ανακαλύψουν προγράμματα σπουδών προσαρμοσμένα στις ανάγκες και τις επιθυμίες τους, κάνοντας τη διαδικασία της αίτησης όσο το δυνατόν πιο εύκολη και γρήγορη. Παράλληλα, στοχεύουμε να παρέχουμε στα πανεπιστήμια ένα απλό αλλά ολοκληρωμένο εργαλείο για τη διαχείριση και την αξιολόγηση αυτών των αιτήσεων.',
    },
    contact: {
      title: 'Επικοινωνήστε μαζί μας',
      par: 'Εάν έχετε ερωτήσεις ή σχόλια, μη διστάσετε να επικοινωνήσετε μαζί μας στο SiG Helpdesk ή στα μέσα κοινωνικής δικτύωσης του SiG.',
    },
  },
  public_survey: {
    header: 'Έρευνα ξενόγλωσσων φοιτητών',
    year: 'Ακαδημαϊκό έτος',
    intro:
      'Καταχωρίστε τους αλλοδαπούς φοιτητές του προγράμματος ανά χώρα καταγωγής και ηλικιακή ομάδα.',
    invalid_link: 'Ο σύνδεσμος δεν είναι έγκυρος ή έχει λήξει.',
    declared_title: 'Έχετε δηλώσει ότι δεν υπάρχουν ξενόγλωσσοι φοιτητές',
    declared_message: 'Αν προσθέσετε στοιχεία, η δήλωση θα αφαιρεθεί αυτόματα.',
    existing_title: 'Καταχωρισμένα στοιχεία',
    add_title: 'Προσθήκη στοιχείων',
    country: 'Χώρα καταγωγής',
    country_rule: 'Επιλέξτε χώρα',
    no_results: 'Δεν βρέθηκαν αποτελέσματα',
    age_group: 'Ηλικιακή ομάδα',
    age_group_rule: 'Επιλέξτε ηλικιακή ομάδα',
    age_groups: { up_to_25: 'Έως 25', over_25: 'Άνω των 25' },
    male: 'Άνδρες',
    female: 'Γυναίκες',
    other: 'Άλλο',
    number_rule: 'Εισάγετε έναν μη αρνητικό ακέραιο αριθμό',
    zero_total: 'Συμπληρώστε τουλάχιστον έναν φοιτητή',
    add_btn: 'Προσθήκη',
    row_saved: 'Τα στοιχεία αποθηκεύτηκαν',
    delete: 'Διαγραφή',
    delete_confirm: 'Να διαγραφεί η εγγραφή {country} ({age_group});',
    row_deleted: 'Η εγγραφή διαγράφηκε',
    no_students_text: 'Δεν έχετε ξενόγλωσσους φοιτητές;',
    no_students_btn: 'Χωρίς ξενόγλωσσους',
    no_students_disabled: 'Διαγράψτε πρώτα τα καταχωρισμένα στοιχεία',
    no_students_confirm:
      'Θα δηλωθεί ότι το πρόγραμμα δεν έχει ξενόγλωσσους φοιτητές για αυτό το έτος.',
    no_students_saved: 'Η δήλωση αποθηκεύτηκε',
    load_error: 'Δεν ήταν δυνατή η φόρτωση της φόρμας',
  },
}
